import React from 'react';
import Dialog from '@components/atoms/dialog/dialog';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import sanitizer from '@helpers/sanitizer';
import styles from './chat-onboarding-modal.module.scss';

type ChatOnboardingModalProps = {
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  gotItText: boolean;
};

const ChatOnboardingModal: React.FC<ChatOnboardingModalProps> = (props) => {
  const { gotItText, isOpen, onClose } = props;
  const { t } = useTranslation();

  const handleCloseDialog = () => {
    onClose(false);
  };

  return (
    <Dialog
      isOpen={isOpen}
      closeDialog={() => handleCloseDialog()}
      key={`openCHATModal${isOpen}`}
      hasCloseIcon
      styles={{
        content: {
          maxWidth: '600px',
        },
      }}
    >
      {(modalDialogTitleId: string) => (
        <div className={clsx(styles.chatOnboardingModal, 'vc-modal__innerContainer')}>
          <h2
            className={clsx(styles.chatOnboardingModal__title, 'vc-modal__title')}
            id={modalDialogTitleId}
          >
            {t('CHAT.MODAL.TITLE')}
          </h2>
          <p className={clsx(styles.chatOnboardingModal__text, 'vc-modal__content')}>{t('CHAT.MODAL.TEXT')}</p>
          <ul className={clsx(styles.chatOnboardingModal__list)}>
            <li>
              <b>{t('CHAT.MODAL.RULE1.TITLE')}</b> {t('CHAT.MODAL.RULE1.TEXT')}
            </li>
            <li>
              <b>{t('CHAT.MODAL.RULE2.TITLE')}</b> {t('CHAT.MODAL.RULE2.TEXT')}
            </li>
            <li>
              <b>{t('CHAT.MODAL.RULE3.TITLE')}</b> {t('CHAT.MODAL.RULE3.TEXT')}
            </li>
            <li>
              <b>{t('CHAT.MODAL.RULE4.TITLE')}</b> {t('CHAT.MODAL.RULE4.TEXT')}
            </li>
          </ul>
          <div
            className={clsx(styles.chatOnboardingModal__warningbox)}
            dangerouslySetInnerHTML={{
              __html: sanitizer(t('CHAT.MODAL.WARNINGMESSAGE')),
            }}
          />
          <button
            type="button"
            data-cy="chat-rules-modal-accept-button"
            onClick={() => handleCloseDialog()}
            className={clsx('vc-btn', 'vc-btn--primary', 'vc-btn--medium', styles.chatOnboardingModal__btn)}
          >
            {gotItText ? t('CHAT.MODAL.GOTIT') : t('CHAT.MODAL.ACCEPTBTN')}
          </button>
        </div>
      )}
    </Dialog>
  );
};

export default ChatOnboardingModal;
